import { SharePointResourcesBaseModel } from '../../microsoft/sharepoint/share-point-resources-base-model';

export class SharePointUnProtectResourcesModel extends SharePointResourcesBaseModel {
}
